"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("./utils");
/**
 * Returns values of ticks so they occur at every step.
 *
 * @param {number} min maximum slider value
 * @param {number} max minimum slider value
 * @param {number} step the amount the handler skips over
 * @returns {array} Array of tick values
 * @private
 */
function getTickValues(min, max, step) {
  let cur = min;
  const tickVals = [];
  while (cur <= max) {
    tickVals.push(cur);
    cur += step;
  }
  return tickVals;
}

/**
 * Determines whether we need an update value range, or just the original tickValue
 *
 * @param {number} tickValue value of the rendered tick (see renderTicks())
 * @param {bool} range determines if slider has multiple thumbs
 * @param {array} value current thumb values
 * @returns {number[]} the calculated value array or just the tickValue
 * @private
 */
function determineTickClickValue(tickValue, range, value) {
  if (range) {
    return determineRangeTickClickValue(tickValue, value);
  }
  return tickValue;
}

/**
 * Determines new value range based on provided tickValue
 *
 * @param {number} tickValue value of the rendered tick (see renderTicks())
 * @param {array} value current thumb values
 * @returns {number[]} the calculated value array
 * @private
 */
function determineRangeTickClickValue(tickValue, value) {
  const [prevLeft, prevRight] = value;
  const distanceFromLeftThumb = Math.abs(tickValue - prevLeft);
  const distanceFromRightThumb = Math.abs(tickValue - prevRight);
  if (distanceFromLeftThumb <= distanceFromRightThumb) {
    return [tickValue, prevRight];
  }
  return [prevLeft, tickValue];
}

/**
 * Returns array of ticks with appropriate className and position.
 *
 * @param {React.PropsWithoutRef} props component props
 * @returns {React.FunctionComponent} Array of rendered ticks
 * @private
 */
function Ticks(_ref) {
  let {
    rtl,
    continuous,
    min,
    max,
    step,
    range,
    value,
    setValue,
    allowClickUpdate,
    clientWidth
  } = _ref;
  const dir = rtl ? 'right' : 'left';
  if (continuous) return null;
  return getTickValues(min, max, step).map(tickVal => {
    const changeValue = () => {
      const newValue = determineTickClickValue(tickVal, range, value);
      setValue(newValue);
    };
    const clickHandler = allowClickUpdate ? changeValue : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: tickVal.toString(),
      className: (0, _classnames.default)('ux-slider-tick-click-area', {
        clickable: allowClickUpdate
      }),
      style: {
        [dir]: (0, _utils.getPositionFromValue)(tickVal, min, max, clientWidth)
      },
      role: "presentation",
      onClick: clickHandler
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "ux-slider-tick"
    }));
  });
}
Ticks.propTypes = {
  rtl: _propTypes.default.bool,
  continuous: _propTypes.default.bool,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  range: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.array]),
  setValue: _propTypes.default.func,
  allowClickUpdate: _propTypes.default.bool,
  clientWidth: _propTypes.default.number
};
var _default = exports.default = Ticks;